import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-solar-loan',
  standalone: true,
  imports: [CommonModule,CarouselModule],
  templateUrl: './solar-loan.component.html',
  styleUrl: './solar-loan.component.scss'
})
export class SolarLoanComponent implements OnInit {
  environment: any = environment;
  public bannerListData: any;
  public pdfListingData: any;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 10,
    margin: 25,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 3,
      },
      768: {
        items: 3,
      },
      1000: {
        items: 3
      },
    },
  };
  constructor(public utils: UtilsService, private metaSvc: MetaMgmtService) {
    let metaData: any = {
      canonicalURL: 'https://www.luminousindia.com/sub-category/solar-loan',
      description: 'Get the solar loan online in India by the leading brand Luminous. The solar power is yours! With Luminous finance. Be in touch today.',
      pageTitle: 'Solar Loan - Get Solar Power Financing Online | Luminous India'
    }
    this.metaSvc.updateMetaTags(metaData);
  }

  ngOnInit(): void {
    this.utils.showLoading();
    this.bannerListData = [
      {
        bannerName: 'Easy finance Options',
        imageUrl: environment.blobUrl+'/assets/images/solar-loan/solar_loan.jpg'
      },
      // {
      //   bannerName: 'Easy finance Options with ICICI',
      //   imageUrl: environment.blobUrl+'/assets/images/solar-loan/ICICI_Bank.jpg'
      // },
      // {
      //   bannerName: 'Easy finance Options with HDFC',
      //   imageUrl: environment.blobUrl+'/assets/images/solar-loan/HDFC_Bank.jpg'
      // },
      // {
      //   bannerName: 'Easy finance Options',
      //   imageUrl: environment.blobUrl+'/assets/images/solar-loan/solar_loan.jpg'
      // }
    ]
    this.pdfListingData = [
      {
        label:'Nationalised Banks',
        banks:[{
          pdfName: 'SBI',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/SBI.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/sbi.png',
        },
        {
          pdfName: 'SIDBI',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/SIDBI.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/sidbi.png',
        },]
      },
      {
        label:'Private Banks',
        banks:[{
          pdfName: 'ICICI',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/ICICI.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/icici.png',
        },   {
          pdfName: 'HDFC',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/HDFC.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/hdfc.png',
        },]
      },
      {
        label:'NBFC/Fintech',
        banks:[{
          pdfName: 'Annapurna Finance',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/Annapurna_Finance.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/Annapurna_Finance.png',
        },
     
        {
          pdfName: 'Credit Fair',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/CreditFair.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/Credit_Fair.png',
        },
        {
          pdfName: 'Ecofy',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/Ecofy.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/ecofy.png',
        }, 
        {
          pdfName: 'Metafin',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/Metafin.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/Metafin.png',
        },
        {
          pdfName: 'EFL',
          pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/EFL.pdf',
          imagePath:  environment.blobUrl+'/assets/images/solar-loan/EFL.png',
        }]
      },
    ];
  }


  viewPDF(url: string) {
    window.open(url, '_blank');
  }

  videoLoaded(): void {
    this.utils.hideLoading();
  }
}
